import { feedback } from "@/mocks/manga";

export default function Feedback() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">读者口碑</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            许多读者都在这里读完了整部作品
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            清晰完整的卷话目录、齐全的全彩与番外收录，让找齐整部作品变得简单。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {feedback.map((f) => (
            <figure key={f.name} className="rounded-2xl bg-background-50 p-6">
              <i className="ri-double-quotes-l text-2xl text-primary-300"></i>
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">{f.content}</blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                  {f.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm font-semibold text-foreground-900">{f.name}</span>
                  <span className="block text-xs text-foreground-500">{f.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}